import { Injectable } from "@angular/core";

import { environment } from "../environments/environment";

import { FileUploader } from "ng2-file-upload";
import { GlobalCfgService } from './globalcfg.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FileUploadService {
  constructor(
    private http: HttpClient,
    private globalCfgService: GlobalCfgService
  ) {}

  getUploader(folder) {
    return new FileUploader({
      url: environment.apiurl + "/FileAttachments/" + folder + "/upload?access_token=" + this.globalCfgService.getAccessToken(),
      autoUpload: true
    });
  }

  fileImport(rec) {
    return this.http.post(environment.apiurl + "/Imports/?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }

  // Epcis file upload which returns list of batches from file
  epcisFileUpload(rec) {
    return this.http.post(environment.apiurl + "/Imports/epcisUpload?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }

  processFileUpload(rec) {
    return this.http.post(environment.apiurl + "/Imports/processUpload?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }
}
